import React, { Fragment } from 'react';
import styles from '../ConsentDetailsPopup/index.styl';
import Icon from '../../../../Icon';

export function renderElectronicConsentHeader(
  formatMessage,
  assignedBy,
  consentName,
  organizationName,
  dateConsent,
) {
  const mainHeaderTitle = formatMessage(
    {
      id: 'appointment.electronicConsent.mainTitle',
    },
    { name: assignedBy },
  );

  const mainHeaderSubtitle = `${consentName}/${organizationName}`;

  return (
    <Fragment>
      <div className={styles.headerLeftSide}>
        <Icon name="icon-consent" size={36} className={styles.icon} />
        <div className={styles.consentDetails}>
          <div className={styles.consentType}>{mainHeaderTitle}</div>
          <div className={styles.consentService}>{mainHeaderSubtitle}</div>
        </div>
      </div>
      <div className={styles.dateConsent}>{dateConsent}</div>
    </Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/VisitConsents/utils/renderElectronicConsentHeader.jsx